/**
 * Frontend runtime environment configuration.
 *
 * Reads `VITE_API_BASE_URL` (injected at build time by Vite) and exposes
 * it as `API_BASE_URL`. If the variable is missing or empty, this module
 * throws immediately at import time so that the app fails fast rather
 * than performing requests against an undefined base URL.
 *
 * Also exposes the optional `VITE_SUPPORT_PHONE` as `SUPPORT_PHONE`. This
 * one is *not* required: the build only fails for `VITE_API_BASE_URL`.
 *
 * Validates: Requirements 1.4, 11.3, 11.4
 */

const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL;

if (typeof rawApiBaseUrl !== 'string' || rawApiBaseUrl.trim().length === 0) {
  throw new Error(
    'VITE_API_BASE_URL is missing or empty. ' +
      'Set VITE_API_BASE_URL at build time (e.g. VITE_API_BASE_URL=https://api.example.com).',
  );
}

export const API_BASE_URL: string = rawApiBaseUrl.trim();

/**
 * Support phone number rendered in the public page footer (Req 1.4).
 * Falls back to an empty string when the build-time variable is missing.
 */
export const SUPPORT_PHONE: string = (
  import.meta.env.VITE_SUPPORT_PHONE ?? ''
).trim();

/**
 * Support email address rendered in the public page footer.
 * Falls back to an empty string when the build-time variable is missing.
 */
export const SUPPORT_EMAIL: string = (
  import.meta.env.VITE_SUPPORT_EMAIL ?? ''
).trim();
